'use strict';

import {Point2D} from '../util/Geometry.js';

export const isMobile = navigator.userAgent.match(/iPhone|iPad|iPod/i) || navigator.userAgent.match(/Android/i);

export function createElement(tagName) {
  return document.createElement(tagName);
}

export function text(txt) {
  return document.createTextNode(txt);
}

export function detach(domEl) {
  if (!domEl.parentNode) {
    return;
  }
  domEl.parentNode.removeChild(domEl);
}

export function empty(domEl) {
  while(domEl.firstChild) {
    domEl.removeChild(domEl.firstChild);
  }
}

const getStyle = (function(){
  const stylePrefixes = ['webkit', 'moz', 'ms', 'o'];
  const styleDic = {
    'background-color': 'backgroundColor',
    'z-index': 'zIndex',
    'box-sizing': 'boxSizing',
    'min-height': 'minHeight',
    'min-width': 'minWidth',
    'max-height': 'maxHeight',
    'max-width': 'maxWidth'
  };
  let testEl = document.createElement('div');

  const hasStyle = function(name){
      return testEl.style[name] != undefined;
  };

  const camelCase = function(name){
    const words = name.split('-');
    const l = words.length;
    for (let i = 1; i < l; i++) {
      words[i] = words[i].substring(0, 1).toUpperCase() + words[i].substring(1);
    }
    return words.join('');
  }

  const findStyle = function(name){
    let target = name;
    if (target.indexOf('-') >= 0) {
      target = camelCase(name);
    }
    if (hasStyle(target)) {
      return target;
    }
    const capitalUpcase = target.substring(0, 1).toUpperCase() + target.substring(1);
    const l = stylePrefixes.length;
    for (let i = 0; i < l; i++) {
      if (hasStyle(stylePrefixes[i] + capitalUpcase)) {
        return stylePrefixes[i] + capitalUpcase;
      }
    }
    return null;
  };

  return function(name){
    return styleDic[name] ? styleDic[name] : findStyle(name);
  }
})();
export function setStyle(domEl, name, value) {
  const sn = getStyle(name);
  if (!sn) {
    return;
  }
  domEl.style[sn] = value;
}
export function setStyles(domEl, name, styleMap) {
  for (let k in styleMap) {
   setStyle(domEl, k, styleMap[k]);
  }
}

export function getAttr(domEl, name) {
  return domEl[name];
}

export function setAttr(domEl, name, value) {
  domEl[name] = value;
}

export function getElementData(domEl) {
  return domEl.dataset;
}

const addEv = (function(){
  // if (window.addEventListener) {
    return function(target, eventName, fn){
      if (eventName == 'mousewheel') {
        target.addEventListener('DOMMouseScroll', fn, false);
      } else if (eventName == 'documentready') {
        target.addEventListener('DOMContentLoaded', fn, false);
      }
      target.addEventListener(eventName, fn);
    };
  // } else if (window.attachEvent) {
  //   return function(target, eventName, fn) {
  //     target.attachEvent('on' + eventName, fn);
  //   };
  // }
})();
export function emptyFunction(){
}
export function preventDefaultHandler(ev){
  ev.preventDefault();
}
export function addEventListener(domEl, name, listener){
  addEv(domEl, name, listener);
}

// delete event
const delEv = (function(){
  // if (window.removeEventListener) {
    return function(target, eventName, fn){
      if (eventName == 'mousewheel') {
        target.removeEventListener('DOMMouseScroll', fn, false);
      } else if (eventName == 'documentready') {
        target.removeEventListener('DOMContentLoaded', fn, false);
      }
      target.removeEventListener(eventName, fn);
    };
  // } else if (window.detachEvent) {
  //   return function(target, eventName, fn) {
  //     target.detachEvent('on' + eventName, fn);
  //   };
  // }
})();
export function removeEventListener(domEl, name, listener){
  delEv(domEl, name, listener);
}

const CustomEvent = (function(){
  if (typeof(window.CustomEvent) === "function" ) return window.CustomEvent; //If not IE

  function CustomEvent(event, params) {
    params = params || {bubbles: false, cancelable: false, detail: undefined};
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
  return CustomEvent;
})();
export function dispatchEvent(domEl, name, params) {
  const ev = new CustomEvent(name, params);
  domEl.dispatchEvent(ev);
}

export function px(v){
  if (typeof(v) == 'number') {
    return v.toFixed(10) + 'px';
  }
  return v;
};
export function setPosition(el, p){
  setPositionXY(el, p.x, p.y);
};
export function setPositionXY(el, x, y){
  el.style.left = px(x);
  el.style.top = px(y);
};
export function setTop(el, top){
  el.style.top = px(top);
};
export function setLeft(el, left){
  el.style.left = px(left);
};
export function setRight(el, right){
  el.style.right = px(right);
};
export function setBottom(el, bottom){
  el.style.bottom = px(bottom);
};
export function setSize(el, size){
  setSizeXY(el, size.x, size.y);
};
export function setSizeXY(el, x, y){
  el.style.width = px(x);
  el.style.height = px(y);
};
export function setWidth(el, width){
  el.style.width = px(width);
};
export function setHeight(el, height){
  el.style.height = px(height);
};
export function getSize(el){
  return new Point2D(el.clientWidth, el.clientHeight);
}
export function getWdith(el){
  return el.clientWidth;
}
export function getHeight(el){
  return el.clientHeight;
}
export function getOffsetSize(el){
  return new Point2D(el.offsetWidth, el.offsetHeight);
};
export function getOffsetWidth(el){
  return el.offsetWidth;
};
export function getOffsetHeight(el){
  return el.offsetHeight;
};
const dummyElement = (function(){
  const el = createElement('div');
  el.style.display = 'block';
  return el;
})();
export function getScrollBarSize(el){
  el.appendChild(dummyElement);
  setSizeXY(dummyElement, el.offsetWidth + 100, el.offsetHeight + 100);
  const pt = new Point2D(el.offsetWidth - el.clientWidth, el.offsetHeight - el.clientHeight);
  el.removeChild(dummyElement);
  return pt;
};

export function getOffsetPosition(el){
  let oel = el;
  if (oel.getBoundingClientRect) {
    const rec = oel.getBoundingClientRect();
    return new Point2D(rec.left, rec.top);
  }
  let top;
  let left;
  while (oel) {
    top = (top || 0) + oel.offsetTop + oel.clientTop;
    left = (left || 0) + oel.offsetLeft + oel.clientLeft;
    oel = oel.offsetParent;
  }
  if (oel != document.documentElement) {
    top = (top || 0) - (document.documentElement.scrollTop || document.body.scrollTop);
    left = (left || 0) - (document.documentElement.scrollLeft || document.body.scrollLeft);
  }
  return new Point2D(left, top);
};

export function getPixel(el, px){
  return px.sub(this.getOffsetPosition(el));
};

export function canvasResize(canvas, size){
  const ratio = Math.max(1, window.devicePixelRatio);
  canvas.width = size.x * ratio;
  canvas.height = size.y * ratio;
};


export function asAbsolute(domEl) {
  domEl.style.position = 'absolute';
  domEl.style.top = '0';
  domEl.style.left = '0';
}

export function asAbsoluteFit(domEl) {
  domEl.style.position = 'absolute';
  domEl.style.top = '0';
  domEl.style.left = '0';
  domEl.style.right = '0';
  domEl.style.bottom = '0';
}

export function noBoundary(domEl){
  domEl.style.margin = '0';
  domEl.style.padding = '0';
  domEl.style.border = '0';
};

export function rotate(el, rad){
  setStyle(el, 'transform', 'rotate(' + (rad * 180 / Math.PI).toFixed(10) + 'deg)');
  return this;
};

export function getTouchPoint(t) {
  return new Point2D(t.clientX, t.clientY);
};

export const generateTouch = function(ev){
  const pt = getTouchPoint(ev);
  return {
    points: [pt],
    center: pt,
    distance: 0,
    angle: 0
  }      
}
export function getTouch(e) {
  // var i, l, ts = e.touches, p, pts = [], cpt, d = 0, a = 0, dpt;
  const ts = e.touches;
  const l = ts ? ts.length : 0;
  const pts = [];
  let cpt;
  let d = 0;
  let a = 0;
  if (l > 0) {
    cpt = new Point2D();
    for (let i = 0; i < l; i++) {
      const p = getTouchPoint(ts[i]);
      pts[i] = p;
      cpt.x += p.x;
      cpt.y += p.y;
    }
    cpt = cpt.div(l);
    if (l > 1) {
      const dpt = pts[0].sub(cpt);
      d = dpt.distance();
      a = dpt.angle();
    }
  }
  return {
    points: pts,
    center: cpt,
    distance: d,
    angle: a
  };
};

export function loadScripts(type, scripts, successCallback, failureCallback) {
  const head = document.documentElement.getElementsByTagName('head').item(0);
  const loadJs = [];
  const l = scripts.length;
  for (let i = 0; i < l; i++) {
    loadJs[i] = scripts[i];
  }
  const loadScript = function(){
    if (!loadJs || loadJs.length <= 0) {
      if (successCallback) {
        successCallback();
      }
      return;
    }
    const script = document.createElement('script');
    script.type = type;
    script.onload = function(){
      loadScript();
    };
    script.onerror = function(){
      if (failureCallback) {
        failureCallback();
      }
    };
    head.appendChild(script);
    script.src = loadJs.shift();
  };
  loadScript();
};

export const fullscreen = (function(){
  if (document.fullscreenEnabled) {
    return function(el){
      el.requestFullscreen()
    }
  } else if (document.webkitFullscreenEnabled) {
    return function(el){
      el.webkitRequestFullscreen()
    }
  } else if (document.mozFullScreenEnabled) {
    return function(el){
      el.mozRequestFullScreen();
    }
  } else if (document.msFullscreenEnabled) {
    return function(el){
      el.msRequestFullscreen();
    }
  } else {
  }
})();

export const cancelFullscreen = (function(){
  if (document.webkitCancelFullScreen) {
    return function(){
      document.webkitCancelFullScreen();
    }
  } else if (document.mozCancelFullScreen) {
    return function(){
      document.mozCancelFullScreen();
    }
  } else if (document.msExitFullscreen) {
    return function(){
      document.msExitFullscreen();
    }
  } else if (document.exitFullscreen) {
    return function(){
      document.exitFullscreen();
    }
  } else {
  }
})();
